module.exports = __webpack_public_path__ + "static/img/server2.bc66edc.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/server2.jpeg
// module id = Po5s
// module chunks = 1